import { render, staticRenderFns } from "./LammieArchive.vue?vue&type=template&id=0a1c6ad7"
import script from "./LammieArchive.vue?vue&type=script&lang=js"
export * from "./LammieArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a1c6ad7')) {
      api.createRecord('0a1c6ad7', component.options)
    } else {
      api.reload('0a1c6ad7', component.options)
    }
    module.hot.accept("./LammieArchive.vue?vue&type=template&id=0a1c6ad7", function () {
      api.rerender('0a1c6ad7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/lammie/LammieArchive.vue"
export default component.exports